import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import PhoneVerification from '../../components/PhoneVerification.js';

const AdvertisingForUser = () => {
  const domain = "https://server.hazran.online";
  const [isVerified, setIsVerified] = useState(false);
  const [advertisements, setAdvertisements] = useState([]);

  // בדיקה אם המשתמש מאומת והבאת הפרסומות
  useEffect(() => {
    const token = Cookies.get('verificationToken');
    const phoneNumber = Cookies.get('phoneNumber');
    if (token && phoneNumber) {
      setIsVerified(true);
      fetchUserAdvertisements();
    }
  }, []);

  // הגדרת רקע וקישור תחתון לעיצוב אחיד
  useEffect(() => {
    document.body.style.backgroundImage = 'url("/background.jpg")';
    document.body.style.backgroundSize = 'cover';
    document.body.style.backgroundPosition = 'center';
    const link = document.createElement('a');
    link.href = 'https://hazran.online';
    link.textContent = ' עזרן - נתב בינה מלאכותית טלפוני hazran.online';
    link.style.display = 'block';
    link.style.textAlign = 'center';
    link.style.marginTop = '20px';
    link.style.color = '#ffffff';
    link.style.textDecoration = 'none';
    link.style.fontSize = '14px';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    return () => {
      document.body.style.backgroundImage = '';
      document.body.style.backgroundSize = '';
      document.body.style.backgroundPosition = '';
      document.body.removeChild(link);
    };
  }, []);

  // פונקציה להבאת פרסומות עבור המשתמש
  const fetchUserAdvertisements = () => {
    fetch(`${domain}/site_api/advertising_management_interface/get_advertising_for_user`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        phone: Cookies.get('phoneNumber'),
        token: Cookies.get('verificationToken')
      })
    })
      .then(response => response.json())
      .then(data => {
        let ads;
        // אם data הוא מערך, נשמור אותו
        if (Array.isArray(data)) {
          ads = data;
        } else if (data.success && data.advertisements) {
          ads = data.advertisements;
        } else {
          alert("לא הצלחנו להביא את הפרסומות");
          return;
        }
        
        // מיון הפרסומות: קודם אלה עם active: 1 ואז לפי תאריך (החדשות ביותר ראשונות)
        ads.sort((a, b) => {
          if (a.active !== b.active) {
            return b.active - a.active;
          }
          return b.date - a.date;
        });
        
        setAdvertisements(ads);
      })
      .catch(error => console.error("Error fetching advertisements:", error));
  };
  

  // אם המשתמש אינו מאומת – מציגים את קומפוננטת האימות
  if (!isVerified) {
    return (
      <PhoneVerification 
        domain={domain} 
        onVerified={() => {
          setIsVerified(true);
          fetchUserAdvertisements();
        }} 
      />
    );
  }

  // עיצוב הקונטיינר הראשי
  const containerStyle = {
    maxWidth: '600px',
    margin: '50px auto',
    padding: '20px',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 0 10px rgba(0,0,0,0.1)',
    textAlign: 'center'
  };

  const headerStyle = {
    marginBottom: '30px',
    color: '#333'
  };

  const buttonStyle = {
    padding: '10px 15px',
    backgroundColor: '#007BFF',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    width: '100%',
    transition: 'transform 0.1s ease'
  };

  // עיצוב לכל פרסומת
  const adStyle = {
    border: '1px solid #ccc',
    borderRadius: '4px',
    padding: '15px',
    marginBottom: '15px',
    backgroundColor: '#f0f8f0', // רקע עדין בגוון כחול בהיר
    textAlign: 'right'
  };

  const adTextStyle = {
    fontWeight: 'bold',
    marginBottom: '8px'
  };

  const statusStyle = (active) => ({
    color: active === 1 ? 'green' : 'red',
    fontWeight: 'bold'
  });

  return (
    <div style={containerStyle}>
      <h2 style={headerStyle}>הקמפיינים שלי</h2>
      {advertisements.length === 0 ? (
        <p>לא נמצאו קמפיינים. לחץ למטה כדי ליצור פרסום חדש.</p>
      ) : (
        <div>
          {advertisements.map((ad, index) => {
            // המרת התאריך מפורמט יוניקס (בשניות) לפורמט קריא בעברית
            const adDateObj = new Date(ad.date * 1000);
            const adDateFormatted = adDateObj.toLocaleDateString('he-IL'); // תאריך
            const adTimeFormatted = adDateObj.toLocaleTimeString('he-IL'); // שעה
            return (
              <div key={index} style={adStyle}>
                <p style={adTextStyle}>{ad.text}</p>
                <p>תאריך: {adDateFormatted} | שעה: {adTimeFormatted}</p>
                <p>מספר שידורים: {ad.counter}</p>
                <p style={statusStyle(ad.active)}>סטאטוס: {ad.active === 1 ? "פעיל" : "לא פעיל"}</p>
              </div>
            );
          })}
        </div>
      )}
      <button
        style={buttonStyle}
        onClick={() => { window.location.href = `/AdvertisingManagementInterface/StartCampaign`; }}
      >
        צור פרסום חדש
      </button>
    </div>
  );
};

export default AdvertisingForUser;
